"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiErrorType = void 0;
var ApiErrorType;
(function (ApiErrorType) {
    ApiErrorType["NotFound"] = "NotFound";
    ApiErrorType["Forbidden"] = "Forbidden";
    ApiErrorType["Unauthorized"] = "Unauthorized";
    ApiErrorType["IdMismatch"] = "IdMismatch";
    ApiErrorType["VersionMismatch"] = "VersionMismatch";
    ApiErrorType["ControllerIsReadOnly"] = "ControllerIsReadOnly";
    ApiErrorType["BadRequest"] = "BadRequest";
    ApiErrorType["UnknownError"] = "UnknownError";
    ApiErrorType["ServerError"] = "ServerError";
})(ApiErrorType = exports.ApiErrorType || (exports.ApiErrorType = {}));
//# sourceMappingURL=ApiError.js.map